// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__fdtOx","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3QbnF","obliqueLine":"membershipbadge_obliqueLine__DpCl6"};